<a
  class="nav-item"
  [class.disabled]="item.disabled === true"
  [class.has-children]="item.children?.length"
  [style.padding-left.px]="16 + depth * 20"
  [id]="item.id"
  [routerLink]="'/' + item.route"
  routerLinkActive="active"
  [routerLinkActiveOptions]="{ exact: true }"
  [matTooltip]="item.toolTip"
  matTooltipPosition="right"
  (click)="onItemNavigate(item, $event)"
  >
  <mat-icon class="nav-item-icon">{{ item.iconName }}</mat-icon>
  <span class="nav-item-label">{{ item.displayName }}</span>
  @if (item.children?.length) {
    <button
      type="button"
      class="nav-item-toggle"
      [attr.aria-label]="(expanded ? 'Collapse ' : 'Expand ') + item.displayName"
      (click)="$event.preventDefault(); $event.stopPropagation(); onItemSelected(item)"
      >
      <mat-icon [@indicatorRotate]="expanded ? 'expanded' : 'collapsed'">expand_more</mat-icon>
    </button>
  }
</a>
@if (expanded) {
  <div class="nav-children">
    @for (child of item.children; track child) {
      <app-menu-list-item [item]="child" [depth]="depth + 1"></app-menu-list-item>
    }
  </div>
}
